import { BookOpen, Bell, FileText, CheckCircle, GraduationCap, Calendar, MapPin, DollarSign } from "lucide-react";
import {
    GeneralInfoText, CollaborationHighlight, HighlightIcon, HighlightText,
    CardsGrid, FeeGrid, FeeItem, FeeLabel, FeeValue, NoticeCard, CardIconWrap, InfoBoxTitle, InfoBoxContent,
    PillRow, Pill, FeeAmount, TextSub,
    ApplicationBox, ApplicationTitle, OrderedList, OrderedListItem, StepNumber,
    ButtonContainer, ApplyButton,
} from "../components/events/amrs-workshop-2026/WorkshopPageContent";
import CoursesSection from "../components/events/amrs-workshop-2026/Courses";
import OutcomeSection from "../components/events/amrs-workshop-2026/LearningOutcomes";
import ReqSection from "../components/events/amrs-workshop-2026/Requirements";
import { jun2026courses, dec2026courses, dec2026details } from "./workshopinfo";

export const dec2026WorkshopSections = [
    { id: 'overview', label: 'General information', icon: BookOpen, content: (
        <>
            <GeneralInfoText>
                The 2026 AMRS-UG workshop is the 8th Edition of a skill training exercise organized by <strong>AMRS Ghana</strong> in partnership with the Department of Materials Science and Enginnering at the <strong>University of Ghana</strong>. This workshop is organised annually with the aim of equipping undergraduate and postgraduate students, researchers, and all other attendees with relevant skills in new-age technologies that are shaping the future of science and engineering.
            </GeneralInfoText>
            <GeneralInfoText>
                This year's workshop will continue its focus on Computational Materials Modelling and Simulation, and will also include short courses on Machine Learning, MATLAB Programming, Solar Power Design and Testing, Density Functional Theory (DFT) Modelling, and more. Computational Modelling and Simulation enable researchers to test innovative ideas, explore material behaviour, and validate experimental outcomes.
            </GeneralInfoText>
            <CollaborationHighlight>
                <HighlightIcon><GraduationCap size={24} color="#CA9D3B" /></HighlightIcon>
                <HighlightText>This workshop represents a training platform aimed at equipping participants with practical skills in Computational Modelling and Simulation, enabling them to undertake experiments and research without the common challenges of physical resource wastage, unavailability of materials, and other limitations associated with conventional experimentation and testing</HighlightText>
            </CollaborationHighlight>
        </>
    )},
    { id: 'notice', label: 'Workshop Details', icon: Bell, content: (
        <CardsGrid>
            <NoticeCard>
                <CardIconWrap><Calendar size={18} color="#0c4e80" /></CardIconWrap>
                <InfoBoxTitle>Duration &amp; Schedule</InfoBoxTitle>
                <InfoBoxContent>Three (3) consecutive days — <strong>2-4 December 2026</strong></InfoBoxContent>
                <PillRow>
                    <Pill $gold>Day 1 & 2 — Mandatory Course</Pill>
                    <Pill>Days 3 — Optional Courses</Pill>
                </PillRow>
            </NoticeCard>
            <NoticeCard>
                <CardIconWrap><MapPin size={18} color="#0c4e80" /></CardIconWrap>
                <InfoBoxTitle>Location</InfoBoxTitle>
                <InfoBoxContent>Toyota Ghana – UG School of Engineering Training Centre, Haatso</InfoBoxContent>
                <TextSub><a href="https://maps.app.goo.gl/9bfuAoSGCixwvuRr7" style={{ color :"#9ca3af"}}>View directions on Google Maps →</a></TextSub>
                </NoticeCard>

            <NoticeCard>
                <CardIconWrap>
                    <DollarSign size={18} color="#0c4e80" />
                </CardIconWrap>

                <InfoBoxTitle>Registration Fee</InfoBoxTitle>

                <FeeGrid>
                    <FeeItem>
                        <FeeLabel>Ghanaian Students</FeeLabel>
                        <FeeValue>GH₵ 500.00</FeeValue>
                    </FeeItem>

                    <FeeItem>
                        <FeeLabel>Non Students</FeeLabel>
                        <FeeValue>GH₵ 750.00</FeeValue>
                    </FeeItem>

                    <FeeItem>
                        <FeeLabel>International Students</FeeLabel>
                        <FeeValue>USD 200.00</FeeValue>
                    </FeeItem>

                    <FeeItem>
                        <FeeLabel>International Non-Students</FeeLabel>
                        <FeeValue>USD 300.00</FeeValue>
                    </FeeItem>
                </FeeGrid>

                <TextSub>
                    One-time payment · Full 3-day access · Deadline: 23rd November 2026
                </TextSub>
            </NoticeCard>
        </CardsGrid>
    )},
    { id: 'requirements', label: 'Requirements', icon: CheckCircle, content: <ReqSection /> }, //Modify ReqSection to accept props depending on workshop
    { id: 'content', label: 'Workshop Modules', icon: FileText, content: <CoursesSection courses={dec2026details.courses} /> },
    { id: 'outcomes', label: 'Learning Outcomes', icon: GraduationCap, content: <OutcomeSection content={dec2026details.outcome} /> },
    { id: 'schedule', label: 'Schedule of activities', icon: FileText, content: (
        <p style={{ fontStyle: "italic" }}>**Schedule is being finalized and will be uploaded soon**</p>
    )},
    { id: 'application', label: 'Application Procedure', icon: FileText, variant: 'highlight', content: (
        <>
            <ApplicationBox>
                <ApplicationTitle>How to Apply</ApplicationTitle>
                        <OrderedList>
                        <OrderedListItem>
                            <StepNumber>1.</StepNumber>
                        <span>Click "Apply Now" button to redirect to the registration page</span>
                        </OrderedListItem>
                        <OrderedListItem>
                            <StepNumber>2.</StepNumber>
                            <span>Fill in the registration form with all essential information</span>
                        </OrderedListItem>
                        <OrderedListItem>
                            <StepNumber>3.</StepNumber>
                            <span>Select a maximum of one (1) optional course for specialization</span>
                        </OrderedListItem>
                        <OrderedListItem>
                            <StepNumber>4.</StepNumber>
                            <span>Proceed to make payment after filling the registration form</span>
                        </OrderedListItem>
                        <OrderedListItem>
                            <StepNumber>5.</StepNumber>
                            <span>If you have submitted your details and have not made payment, click <a href = "/event/payment-initializer" style={{color : "#CA9D3B"}}>here</a> pay and confirm your application.</span>
                        </OrderedListItem>
                        <span style={{ marginTop : "1rem", textAlign : "center", fontSize : "1.3rem"}}> Deadline for confirming application is set for 23rd November</span>
                        </OrderedList>
            </ApplicationBox>
            <ButtonContainer>
                <ApplyButton onClick={() => window.location.href = '/amrs-dec-2026-workshop/register'}>
                    Apply Now
                </ApplyButton>
            </ButtonContainer>
        </>
    )},
];